import { Select, Space, Typography } from 'antd';
import { useI18n } from '../i18n';

export function LocaleSwitcher() {
  const { locale, localeMode, setLocale, t, useSystemLocale } = useI18n();
  const options = [
    { value: 'SYSTEM', label: t('common.language_follow_system') },
    { value: 'zh-CN', label: t('common.language_zh_cn') },
    { value: 'zh-TW', label: t('common.language_zh_tw') },
    { value: 'en-US', label: t('common.language_en_us') },
  ];
  return <Space size={6} align="center" aria-label={t('common.language')}>
    <Typography.Text type="secondary">{t('common.language')}</Typography.Text>
    <Select
      size="small"
      aria-label={t('common.language')}
      value={localeMode === 'SYSTEM' ? 'SYSTEM' : locale}
      options={options}
      onChange={(value: string) => value === 'SYSTEM' ? useSystemLocale() : setLocale(value as typeof locale)}
      style={{ minWidth: 128 }}
    />
  </Space>;
}

export default LocaleSwitcher;
